//All components are compiled together here

import React from 'react';

import Title from './1_Title/Title';
import WhatIsZiplyne from './2_WhatIsZiplyne/WhatIsZiplyne';
import Benefits from './3_Benefits/Benefits';
import JHUTeams from './4_JHUTeams/JHUTeams';
import ZiplynesImpact from './5_ZiplynesImpact/ZiplynesImpact';
import Zipster from './6_Zipster/Zipster';
import TrainingDates from './7_TrainingDates/TrainingDates';
import Workflow from './9_Workflow/Workflow';
import EmbedForm from './10_EmbedForm/EmbedForm'
import FAQs from './8_FAQs/FAQs';
import Footer from './Footer/Footer'

export default class HopkinsZiplyneApp extends React.Component {

    render() {
        return (
            <>
                <div className = "HopkinsZiplyneApp">
                    <Title />
                    <WhatIsZiplyne />
                    <Benefits />
                    <ZiplynesImpact />
                    <JHUTeams />
                    <Zipster />
                    <TrainingDates />
                    <Workflow />
                    <EmbedForm />
                    <FAQs />          
                </div>
                <Footer />
            </>
        );
    }
}

